import {FloorPlanEditorViewActions, FloorPlanEditorViewActionTypes} from '../actions/floor-plan-editor-view.actions';
import {ImageWithSource, RemoveFloorImageCompletePayload, UploadFloorImageCompletePayload} from '../models/floor-plan-editor-view';
import {ErrorPayload} from '../../afb-api/models/general';

export interface State {
  selectedFloorId: string | null;
  uploadedImageWithSource: ImageWithSource | null;
  didFloorImageChange: boolean;
  saveFloorPlanLoading: boolean;
  saveFloorPlanLoaded: boolean;
  saveFloorPlanError: string | null;
}

export const initialState: State = {
  selectedFloorId: null,
  uploadedImageWithSource: null,
  didFloorImageChange: false,
  saveFloorPlanLoading: false,
  saveFloorPlanLoaded: false,
  saveFloorPlanError: null
};

export function reducer(state = initialState, action: FloorPlanEditorViewActions): State {
  switch (action.type) {

    case FloorPlanEditorViewActionTypes.SelectFloor: {
      const newSelectedFloorId: string = action.payload;
      return {
        ...state,
        selectedFloorId: newSelectedFloorId
      };
    }

    case FloorPlanEditorViewActionTypes.DeselectFloor: {
      return {
        ...state,
        selectedFloorId: null
      };
    }

    case FloorPlanEditorViewActionTypes.UploadFloorImageComplete: {
      const uploadFloorImageCompletePayload: UploadFloorImageCompletePayload = action.payload;

      return {
        ...state,
        uploadedImageWithSource: uploadFloorImageCompletePayload.imageWithSource,
        didFloorImageChange: uploadFloorImageCompletePayload.didFloorImageChange
      };
    }

    case FloorPlanEditorViewActionTypes.RemoveFloorImageComplete: {
      const removeFloorImageCompletePayload: RemoveFloorImageCompletePayload = action.payload;
      return {
        ...state,
        uploadedImageWithSource: null,
        didFloorImageChange: removeFloorImageCompletePayload.didFloorImageChange
      };
    }

    case FloorPlanEditorViewActionTypes.ResetFloorImage: {
      return {
        ...state,
        uploadedImageWithSource: null,
        didFloorImageChange: false
      };
    }

    case FloorPlanEditorViewActionTypes.ResetFloorImageChangeStatus: {
      return {
        ...state,
        didFloorImageChange: false
      };
    }

    case FloorPlanEditorViewActionTypes.SaveFloorPlan: {
      return {
        ...state,
        saveFloorPlanLoading: true,
        saveFloorPlanLoaded: false,
        saveFloorPlanError: null
      };
    }

    case FloorPlanEditorViewActionTypes.SaveFloorPlanSuccess: {
      return {
        ...state,
        saveFloorPlanLoading: false,
        saveFloorPlanLoaded: true
      };
    }

    case FloorPlanEditorViewActionTypes.SaveFloorPlanFail: {
      const errorPayload: ErrorPayload = action.payload;
      return {
        ...state,
        saveFloorPlanLoading: false,
        saveFloorPlanLoaded: false,
        saveFloorPlanError: errorPayload.errorMessage
      };
    }

    default:
      return state;
  }
}

export const selectedFloorId = (state: State) => state.selectedFloorId;
export const uploadedImageWithSource = (state: State) => state.uploadedImageWithSource;
export const didFloorImageChange = (state: State) => state.didFloorImageChange;
export const saveFloorPlanLoading = (state: State) => state.saveFloorPlanLoading;
export const saveFloorPlanLoaded = (state: State) => state.saveFloorPlanLoaded;
export const saveFloorPlanError = (state: State) => state.saveFloorPlanError;
